/**
 * @expFlag auth-mobile-redirect-app-main-actions
 * @ticket CLOUDWEB-20237
 * @file
 */
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { AllFunctionsInAppModalProps } from './AllFunctionsInAppModal.types';

export const renderAllFunctionsInAppModalDialog = (data: AllFunctionsInAppModalProps) =>
    openPopupHelper({ popupName: popupNames.ALL_FUNCTIONS_IN_APP_MODAL, data });
